import { render, staticRenderFns } from "./app-bar-account.vue?vue&type=template&id=df848246&scoped=true&lang=pug&"
import script from "./app-bar-account.vue?vue&type=script&lang=ts&"
export * from "./app-bar-account.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df848246",
  null
  
)

export default component.exports